import React from "react";
import { ProgressBarWrapper, ProgressBoxWrapper } from "./style";

function ProgressBar({children,value="0%", title="Profile Registration"}) {
  const num = parseInt(String(value).replace(/[^0-9]/g, ""), 10);
  const safeValue = (!isNaN(num) && num > 0) ? `${num}%` : "30%";
  return (
    <ProgressBarWrapper>
      <div className="flex">
        <h2>{title}</h2>
         <ProgressBarBox value={safeValue} />
         <span className="pb-percent">{safeValue}</span>
         {children}
      </div>
      <p>Register now to explore a range of tailored services just for you. Once registered, our loan service will be available to meet your financial needs.</p>
    </ProgressBarWrapper>
  );
}

export default ProgressBar;

export function ProgressBarBox({value}) {
  return (
    <ProgressBoxWrapper className="progress">
      <div className="progress-bar" style={{ width: value }}></div>
    </ProgressBoxWrapper>
  );
}
